import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=6d84b31f&"
import script from "./EmailTemplates.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports